import closeIcon from 'assets/scheduling/close.svg';
import { useSelector } from 'react-redux';
import activePositionTabSelector from 'store/selectors/scheduleSelectors/activePositionTabSelector';
import { useScheduleActions } from 'store/reducers/scheduleSlice/scheduleSlice';
import getElementById from 'utils/getElementById';
import { SearchedMembersIcon, StyledTab, TabCloseButton, TabLabel } from './index.styled';
import { Wrapper } from './NewTabInput.styled';
import { useTranslation } from 'hooks/useTranslation';
import { MouseEvent } from 'react';

export const SEARCHED_MEMBERS_TAB = 'SearchedMembers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SearchedMembersTab(props: any) {
  const ID = 'TAB_SEARCHED_MEMBERS';
  const { removePositionTab, setActiveTab, setSelectedJaneIds } = useScheduleActions();
  const activeTab = useSelector(activePositionTabSelector);

  const isActive = activeTab === SEARCHED_MEMBERS_TAB;

  const { t } = useTranslation();

  function handleCloseTab(event: MouseEvent) {
    event.stopPropagation();
    removePositionTab(SEARCHED_MEMBERS_TAB);
    setSelectedJaneIds([]);
  }

  function handleTabClick() {
    if (!isActive) {
      setActiveTab(SEARCHED_MEMBERS_TAB);

      const element = getElementById(ID);

      if (element && element.scrollIntoView && typeof element.scrollIntoView === 'function') {
        element.scrollIntoView(true);
      }
    }
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleTabClick();
    }
  }

  return (
    <Wrapper id={ID}>
      <StyledTab
        role="tab"
        aria-selected={isActive}
        isActive={isActive}
        tabIndex={0}
        onClick={handleTabClick}
        onKeyDown={handleKeyDown}
        {...props}
      >
        <SearchedMembersIcon />
        <TabLabel isActive={isActive}>{t('schedule:SEARCHED_MEMBERS')}</TabLabel>

        <TabCloseButton onClick={handleCloseTab}>
          <img alt="Close Icon" width={12} height={12} src={closeIcon} />
        </TabCloseButton>
      </StyledTab>
    </Wrapper>
  );
}

SearchedMembersTab.propTypes = {};

export default SearchedMembersTab;
